import firebaseApp from "@/config/firebaseApp";
import type { MarketConfiguration } from "@/config/markets/const";
import type { Auth } from "firebase/auth";

export default async function initAuthClient(
  marketConfig: MarketConfiguration,
): Promise<Auth> {
  const {
    initializeAuth,
    getAuth,
    indexedDBLocalPersistence,
    browserLocalPersistence,
  } = await import("firebase/auth");

  let client: Auth;
  try {
    client = initializeAuth(firebaseApp, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });
  } catch {
    client = getAuth(firebaseApp);
  }

  client.languageCode = marketConfig.language.code;

  return client;
}
